import { resolveImagePath } from '@/utils/imageResolver.ts';

export interface WelcomeSectionProps {
  className?: string;
}

export function WelcomeSection({ className = "" }: WelcomeSectionProps) {
  return (
    <div className={`space-y-6 ${className}`}>
      {/* Page Title */}
      <h1 className="text-4xl font-bold text-black" style={{ fontFamily: 'Arial', fontSize: '36px' }}>
        Home
      </h1>
      
      {/* Welcome Message */}
      <h2 className="text-2xl text-black" style={{ fontSize: '24px' }}>
        Welcome to the Official Falmouth Airpark Website!
      </h2>
      
      {/* Hangar Information */}
      <p className="text-lg text-black" style={{ fontSize: '18px' }}>
        All our hangars are rented, but to be put on the waiting list, email the Airport Manager:{' '}
        <a href="mailto:5b6manager@gmail.com" className="text-blue-600 hover:underline">
          5b6manager@gmail.com
        </a>
      </p>
      
      {/* Swift Fuel Notice */}
      <p className="text-lg font-bold" style={{ color: '#FF4040', fontSize: '18px' }}>
        Swift Fuel UL94 is available
      </p>
      
      {/* Email Notification */}
      <p className="text-base text-black">
        To get an email when 94UL arrives or is sold out, send a message to{' '}
        <a href="mailto:fahawebmaster@gmail.com" className="text-blue-600 hover:underline">
          fahawebmaster@gmail.com
        </a>
      </p>
      
      {/* Location Information */}
      <p className="text-lg text-black">We are located in Falmouth, MA on Cape Cod</p>
      
      {/* Mailing Address */}
      <div className="space-y-1">
        <p className="font-bold text-black">Mailing Address:</p>
        <p className="text-black">FAHA</p>
        <p className="text-black">PO Box 2011</p>
        <p className="text-black">Teaticket, MA 02536-2011</p>
      </div>
      
      {/* Aerial Image */}
      <div className="my-8">
        {resolveImagePath('/aerial31.jpg') && (
          <img 
            src={resolveImagePath('/aerial31.jpg')} 
            alt="Aerial view of Falmouth Airpark"
            className="max-w-full h-auto"
          />
        )}
      </div>
      
      {/* Footer Information */}
      <div className="space-y-2 text-sm text-black">
        <p>All web content subject to Board/Management approval</p>
        <p>© 2010-2025 Falmouth Airpark Homeowners Association</p>
        <p>
          Contact us:{' '}
          <a href="mailto:fahawebmaster@gmail.com" className="text-blue-600 hover:underline">
            fahawebmaster@gmail.com
          </a>
        </p>
      </div>
    </div>
  );
}